import React from 'react';
import { omit, isEqual } from 'lodash';
import Panel from '../../../../components/outline/Panel';
import Button from '../../../../components/Button';
import './BrandExposureHeader.scss';

const BrandExposureHeader = (props) => {
  const { brandExposureList, pageType, editBrandExposureListRequest, resetBrandExposureInfo } = props;
  const { originList, newList } = brandExposureList;

  return (
    <Panel className="brand-exposure-header">
      {/*변경사항 저장*/}
      {/*originList 와 newList 에서 listStatus 속성을 뺀 값을 비교해서 같으면 수정이 안된 것이므로 disabled*/}
      <div className="brand-exposure-header-section">
        <Button
          color="primary"
          text="저장하기"
          disabled={isEqual(
            originList,
            newList.map((item) => omit(item, 'listStatus')),
          )}
          onClick={() => {
            editBrandExposureListRequest({
              newList,
              tableType: pageType,
            });
          }}
        />

        <Button text="초기화" onClick={resetBrandExposureInfo} />
      </div>
    </Panel>
  );
};

export default BrandExposureHeader;
